<template>
  <div class="submit-container" id="submitContainer">
    <div class="coupon-info-wrap">
      <div
        id="couponInfo"
        class="coupon-info j-select-coupon-entry"
        v-if="+curPayType.coupon === 1"
        @click="togglePaytypeCouponPopup"
      >
        <span v-if="paytypeActiveCouponId" class="coupon-detail-wrap">
          <span>{{ letter.couponHasSelectQuan }}：</span>

          <span class="coupon-detail" v-if="activePaytypeCouponFullReductType">
            {{ activePaytypeCouponInfo.DESCRIPTION }}
            {{ activePaytypeCouponReductionName }}
            <span
              class="coupon-cancel iconfont icon-close j-cancel-choose-coupon"
              @click.stop="cancelChooseCoupon"
            ></span>
          </span>
          <span v-else class="coupon-detail">
            {{ activePaytypeCouponInfo.DESCRIPTION }}
            {{ activePaytypeCouponDiscountName }}
            <span
              class="coupon-cancel iconfont icon-close j-cancel-choose-coupon"
              @click.stop="cancelChooseCoupon"
            ></span>
          </span>
        </span>
        <span v-else>{{ letter.voucherChooseCoupon }}</span>
        <em class="ico" :class="{ close: isShowPaytypePopupCoupon }"></em>
      </div>
      <div id="couponInfo" class="coupon-info default" v-else>
        <span>{{
          +gameId === 274 && lang === 'vi-VN'
            ? ''
            : letter.voucherPaytypeNotSupport
        }}</span>
      </div>
      <coupon-list-popup
        v-if="isShowPaytypePopupCoupon"
        popupType="paytype"
        :enableCouponList="paytypeEnableCouponList"
        :disableCouponList="paytypeDisableCouponList"
        :expireCouponList="paytypeExpireCouponList"
        :activeId="paytypeActiveCouponId"
        :showItemUseBtn="true"
        :languages="letter"
        @closeCouponPopup="hidePaytypeCouponPopup"
        :isPopup="false"
      ></coupon-list-popup>
    </div>
    <div class="order-container">
      <div class="order-detail">
        <div
          class="order-detail-content"
          :class="{ hasSelectQuan: paytypeActiveCouponId }"
        >
          <template>
            {{ curProductDesc }}
            <pay-ico
              :ico="
                isJpPlatform
                  ? productDefaultIco
                  : curProduct.PRODUCT_ICON || productDefaultIco
              "
            ></pay-ico>
          </template>
          <template v-if="+curProduct.PRODUCT_EXTRA_COIN">
            <span style="margin: 0 5px">+</span
            >{{ curProduct.PRODUCT_EXTRA_COIN
            }}<pay-ico
              :ico="
                +gameId === 371
                  ? '//cdnimages.awselbcombine.com/public_images/one_image/2024/05/171584266376490469.png'
                  : coinIco
              "
            ></pay-ico>
          </template>
          <template v-if="+curPriceSubCoin">
            <span style="margin: 0 5px">+</span>{{ curPriceSubCoin
            }}<pay-ico :ico="subCoinIco"></pay-ico>
          </template>
          <template v-if="+curPriceExtraCoin"
            ><span style="margin: 0 5px">+</span>{{ curPriceExtraCoin
            }}<pay-ico :ico="extraCoinIco"></pay-ico
          ></template>
        </div>
        <div class="order-detail-price">
          <p class="discount-price" v-if="curPayType.coupon">
            <span class="total">{{ letter.storeTotal }}：</span>
            <span class="price-wrap">
              <span class="discount-total"
                >{{ discountTransMount }} {{ curPayType.show_currency }}</span
              >
              <span class="price-total coupon" v-if="paytypeActiveCouponId"
                >{{ transMount }} {{ curPayType.show_currency }}
                <span style="margin-left: 5px"></span>
                <template v-if="activePaytypeCouponFullReductType">
                  {{ activePaytypeCouponReductionName }}
                </template>
                <template v-else>
                  {{ activePaytypeCouponDiscountName }}
                </template>
              </span>
            </span>
            <span class="price-tax" v-if="isShowTax">
              {{
                `+${curTax}${curPayType ? curPayType.show_currency : ''}(tax)`
              }}
            </span>
          </p>
          <p class="price" v-else>
            {{ letter.storeTotal }}：
            <span class="price-total"
              >{{ transMount }} {{ curPayType.show_currency }}
              <span v-if="isShowTax">
                {{
                  `+${curTax}${curPayType ? curPayType.show_currency : ''}(tax)`
                }}
              </span>
            </span>
          </p>
        </div>
      </div>
      <Button
        class="submit-btn normal-btn j-submit-nbtn"
        @click="postOrder"
        pointClass="j-submit-dcount j-submit-nbtn"
        :loading="submitLoading"
      >
        {{ submitOrderBtnText }}
      </Button>
    </div>
  </div>
</template>

<script>
import coupon from '@mixins/officialWebStore/coupon';
import product from '@mixins/officialWebStore/product';
import zipcode from '@mixins/officialWebStore/zipcode';
import CouponListPopup from '@components/officialWebStore/coupon/CouponListPopup.vue';
import PayIco from '@components/officialWebStore/paytype/PayIco.vue';
import { mapGetters, mapState } from 'vuex';
import { popupType, clickButton } from '@plugins/biPoint/_configWebstoreV2';

export default {
  name: 'SubmitFooter',
  mixins: [coupon, product, zipcode],
  props: [
    'curPayType',
    'curProduct',
    'curPriceSubCoin',
    'coinName',
    'submitLoading',
    'discountTransMount',
    'transMount',
    'curPriceExtraCoin'
  ],
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      isUidLogin: state => state.login.isUidLogin,
      lang: state => state.lang,
      curLocation: state => state.curLocation,
      zipCode: state => state.zipCode,
      curTax: state => state.curTax
    }),
    ...mapGetters([
      'getPointPayChannelName',
      'isJpPlatform',
      'subCoinNama',
      'subCoinIco',
      'extraCoinName',
      'extraCoinIco',
      'coinIco'
    ]),
    submitOrderBtnText() {
      // 2024.10.31 日本平台(平台币 or 其他渠道选了优惠券) 且 uid登录
      if (this.isJpPlatform) {
        let _isCoinsPay =
          this.curPayType &&
          this.curPayType.f_pay_type === this.getPointPayChannelName;
        if ((_isCoinsPay || this.paytypeActiveCouponId) && this.isUidLogin) {
          return this.letter.jpUidLoginName;
        } else {
          return this.letter.submitOrder;
        }
      }
      if (
        this.curPayType &&
        this.curPayType.f_pay_type === this.getPointPayChannelName &&
        this.isUidLogin
      ) {
        return this.letter.uidLoginName;
      } else {
        return this.letter.submitOrder;
      }
    },
    curProductDesc() {
      // 2024/01/30 需求变更：寻道大千全球版只显示数量+icon
      if (+this.gameId === 339) {
        return this.curProduct.COIN;
      }
      return (
        this.curProduct?.CP_PRODUCT_DESC || this.curProduct?.PRODUCT_DESC || ''
      );
    },
    isShowTax() {
      return +this.curTax > 0 && this.curLocation === 'US';
    },
    getRefreshTax() {
      const { curLocation, discountTransMount, zipCode } = this;
      return {
        curLocation,
        discountTransMount,
        zipCode
      };
    }
  },
  watch: {
    getRefreshTax: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (
          newVal.curLocation === 'US' &&
          newVal.discountTransMount &&
          newVal.zipCode &&
          this.curPayType.show_currency === 'USD'
        ) {
          this.getCurrentTax({
            zipCode: newVal.zipCode,
            amount: newVal.discountTransMount,
            currency: this.curPayType.show_currency
          });
        }
      }
    }
  },
  methods: {
    postOrder() {
      this.$emit('postOrder');
    },
    togglePaytypeCouponPopup() {
      if (this.isShowPaytypePopupCoupon) {
        this.hidePaytypeCouponPopup();
      } else {
        this.showPaytypeCouponPopup();
      }
    },
    cancelChooseCoupon() {
      clickButton({
        btnName: 'cancel_choose_coupon',
        locationKey: popupType.paytypeCouponPopup
      });
      this.hidePaytypeCouponPopup();
      this.updatePaytypeActiveCouponId('');
    }
  },
  components: {
    CouponListPopup,
    PayIco
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.price-tax {
  color: $btnBg;
}
.submit-container {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 8;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  font-size: 0;
}

.coupon-info-wrap {
  position: absolute;
  width: 100%;
  bottom: 156px;
}
.order-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  padding: 34px 20px;
  width: 100%;
  height: 158px;
}

.order-detail {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .order-detail-content {
    font-size: 30px;
    color: #333;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    &.hasSelectQuan {
      margin-bottom: 7px;
    }
    .product-name {
      display: inline-block;
    }
    img {
      width: 30px;
    }
  }
  .order-detail-price {
    font-size: 24px;
    .discount-price {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      .total {
        font-weight: normal;
        font-size: 24px;
      }
      .price-wrap {
        display: flex;
        flex-direction: column;
        color: $btnBg;
        font-size: 40px;
      }
      .discount-total {
        font-size: 40px;
      }
      .price-total {
        text-decoration: line-through;
        text-decoration-color: $btnBg;
        font-size: 40px;
        color: $btnBg;
        &.coupon {
          font-size: 22px;
          font-weight: normal;
        }
      }
    }
    .price {
      font-size: 24px;
      color: #333;
      display: flex;
      align-items: center;
      .price-total {
        font-size: 40px;
        color: $btnBg;
        font-weight: bold;
      }
    }
  }
}

.submit-btn {
  color: #fff;
  font-size: 28px;
  padding: 20px 30px;
  border-radius: 50px;
  box-sizing: border-box;
  background: $btnBg;
}

.coupon-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 24px;
  color: #333;
  padding: 0 20px;
  height: 80px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background: #fff;
  cursor: pointer;
  box-shadow: 0px -4px 6px -2px $borderActiveShade;
  border: 1px solid #dddddd;
  &.default {
    cursor: default;
  }
  .coupon-detail-wrap {
    display: flex;
    align-items: center;
  }
  .coupon-detail {
    display: flex;
    align-items: center;
    color: #333;
    font-size: 24px;
    border-radius: 9px;
    padding: 5px 15px;
    background: #fff;
    border: 1px solid $btnBg;
  }

  .coupon-cancel {
    display: inline-block;
    margin-left: 10px;
    cursor: pointer;
    font-size: 30px;
  }

  .ico {
    display: inline-block;
    width: 21px;
    height: 20px;
    background: url($tmslgImg + 'open-coupon-popup-ico.png') no-repeat;
    &.close {
      background: url($tmslgImg + 'close-coupon-popup-ico.png') no-repeat;
    }
  }
}

@media screen and (orientation: landscape) {
  .submit-container {
    width: 898px;
    left: unset;
    margin-left: -20px;
  }
  .order-container {
    height: 124px;
    padding: 26px 20px;
  }
  .coupon-info-wrap {
    bottom: 124px;
    ::v-deep .coupon-list-popup-content-scroll {
      height: 165px;
    }
  }

  .order-detail {
    .order-detail-content {
      font-size: 18px;
    }
    .order-detail-price {
      font-size: 28px;
      .discount-price {
        .total {
          font-size: 22px;
        }
        .discount-total {
          font-size: 28px;
        }
        .price-total {
          font-size: 28px;

          &.coupon {
            font-size: 16px;
          }
        }
      }
      .price {
        font-size: 22px;

        .price-total {
          font-size: 28px;
        }
      }
    }
  }

  .submit-btn {
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    align-self: center;
  }

  .coupon-info {
    font-size: 22px;
    height: 58px;
    box-sizing: border-box;
    .coupon-detail-wrap {
      display: flex;
      align-items: center;
    }
    .coupon-detail {
      font-size: 22px;
      padding: 2px 10px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .coupon-info-wrap {
    ::v-deep .coupon-list-popup-content-scroll {
      height: 373px;
    }
  }
}
</style>
